// extracted by mini-css-extract-plugin
export var numberInputContainer = "_8b-0";
export var startPickingButton = "_8b-1";